// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Badge,
//   Button,
//   Stack,
//   Alert,
//   AlertIcon,
//   Switch,
//   Checkbox,
//   CheckboxGroup,
//   HStack,
//   useColorModeValue,
//   Input,
//   Select,
//   Radio,
//   RadioGroup,
//   Flex,
//   Text,
//   Image,
//   Icon
// } from "@chakra-ui/react";
// import { EditIcon, CheckIcon, CloseIcon, DeleteIcon } from "@chakra-ui/icons";
// import _ from "lodash";

// const ExpandedComponent = (props) => {
//   const {
//     keywordId,
//     searchTermList,
//     platforms,
//     selectedSearchTerms,
//     onSearchTermCheck,
//     onSearchTermSave,
//     onSuccessAlert,
//     onFailureAlert,
//     fetchKeywords
//   } = props;

//   const backendUrl = process.env.REACT_APP_BACKEND_URL;
//   const [data, setData] = useState([]);
//   const [tempSearchTerms, setTempSearchTerms] = useState([]);
//   const [newSearchTerm, setNewSearchTerm] = useState("");
//   const [newStatus, setNewStatus] = useState(0);
//   const [selectedPlatform, setSelectedPlatform] = useState("");
//   const [showSaveButton, setShowSaveButton] = useState(false);
//   const [inputError, setInputError] = useState(false);

//   useEffect(() => {
//     if (searchTermList) {
//       setData(searchTermList);
//     }
//   }, [searchTermList]);

//   const handleAddSearchTerm = () => {
//     if (!newSearchTerm || !selectedPlatform) {
//       setInputError(true);
//       onFailureAlert("Please fill all required fields");
//       return;
//     }

//     const newItem = {
//       keyword_id: keywordId,
//       search_term: newSearchTerm,
//       pst_status: parseInt(newStatus),
//       platform_id: parseInt(selectedPlatform),
//       isTemp: true
//     };

//     setTempSearchTerms([...tempSearchTerms, newItem]);
//     setData([...data, newItem]);
//     setNewSearchTerm("");
//     setSelectedPlatform("");
//     setShowSaveButton(true);
//     setInputError(false);
//   };

//   const handleSaveAll = async () => {
//     if (tempSearchTerms.length === 0) {
//       onSuccessAlert("No changes to save");
//       return;
//     }

//     const searchTermsToSave = tempSearchTerms.map(term => ({
//       search_term: term.search_term,
//       platform_id: term.platform_id,
//       status: term.pst_status
//     }));

//     try {
//       const response = await fetch(`${backendUrl}/api/keyword/insertPst`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           keywords: data,
//         }),
//       });

//       const json = await response.json();

//       if (response.ok) {
//         onSuccessAlert("Changes Saved");
//         fetchKeywords();
//       } else if (response.status === 400) {
//         onFailureAlert("Error in insertion");
//       }
//     } catch (err) {
//       onFailureAlert("Error in insertion");
//     }

//     await onSearchTermSave(searchTermsToSave, keywordId);
//     setTempSearchTerms([]);
//     setShowSaveButton(false);
//   };

//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");

//   return (
//     <Tr>
//       <Td colSpan={6} style={{ padding: "10px" }} color={textColor}>
//         {/* Table */}
//         <Table variant="simple" size="sm">
//           <Thead bg={borderColor}>
//             <Tr>
//               <Th></Th>
//               <Th>SR</Th>
//               <Th>Search Term</Th>
//               <Th>Status</Th>
//               <Th>Platform</Th>
//               {/* <Th>Actions</Th> */}
//             </Tr>
//           </Thead>
//           <Tbody>
//             {/* Existing search terms */}
//             {data
//               .filter((it) => it.pst_id || it.isTemp)
//               .map((item, index) => (
//                 <Tr key={item.pst_id || item.temp_id}>
//                   <Td>
//                     <Checkbox
//                       isChecked={selectedSearchTerms[keywordId]?.includes(
//                         item.pst_id
//                       )}
//                       onChange={() => onSearchTermCheck(keywordId, item.pst_id)}
//                       isDisabled={item.isTemp}
//                     />
//                   </Td>
//                   <Td>{index + 1}</Td>
//                   <Td>{item.search_term}</Td>
//                   <Td>
//                     <Switch
//                       isChecked={item.pst_status === 1}
//                       colorScheme="teal"
//                     />
//                   </Td>
//                   <Td color={item.pmp_status === 1 ? "" : "gray.400"}>
//                     {item.platform_name}
//                   </Td>
//                   {/* <Td>
//                     <Button
//                       size="xs"
//                       colorScheme="blue"
//                       leftIcon={<EditIcon />}
//                       onClick={() => handleEdit(item.pst_id)}
//                     >
//                       Edit
//                     </Button>
//                   </Td> */}
//                 </Tr>
//               ))}

//             {/* New search term input row */}
//             <Tr>
//               <Td></Td>
//               <Td>{data.length + 1}</Td>
//               <Td>
//                 <Input
//                   placeholder="Enter search term"
//                   value={newSearchTerm}
//                   onChange={(e) => setNewSearchTerm(e.target.value)}
//                   size="sm"
//                   isInvalid={inputError && !newSearchTerm}
//                 />
//               </Td>
//               <Td>
//                 <Switch
//                   isChecked={newStatus === 1}
//                   value={newStatus}
//                   onChange={() => setNewStatus(newStatus === 1 ? 0 : 1)}
//                   colorScheme="teal"
//                 />
//               </Td>
//               <Td>
//                 <Select
//                   placeholder="Select platform"
//                   value={selectedPlatform}
//                   onChange={(e) => setSelectedPlatform(e.target.value)}
//                   size="sm"
//                   isInvalid={inputError && !selectedPlatform}
//                 >
//                   {platforms.map((platform) => (
//                     <option key={platform.id} value={platform.id}>
//                       {platform.platform_name}
//                     </option>
//                   ))}
//                 </Select>
//               </Td>
//               <Td>
//                 <Button
//                   colorScheme="messenger"
//                   size="sm"
//                   onClick={handleAddSearchTerm}
//                 >
//                   Add +
//                 </Button>
//               </Td>
//             </Tr>
//           </Tbody>
//         </Table>

//         {/* Save All Changes Button */}
//         {showSaveButton && (
//           <Button
//             mt={4}
//             colorScheme="messenger"
//             leftIcon={<CheckIcon />}
//             onClick={handleSaveAll}
//           >
//             Save All Changes
//           </Button>
//         )}
//       </Td>
//     </Tr>
//   );
// };

// export default ExpandedComponent;


// import React, { useState, useEffect } from "react";
// import {
//   Table,
//   Thead,
//   Tbody,
//   Tr,
//   Th,
//   Td,
//   Badge,
//   Button,
//   Stack,
//   Alert,
//   AlertIcon,
//   Switch,
//   Checkbox,
//   HStack,
//   VStack,
//   useColorModeValue,
//   Input,
//   Select,
//   Flex,
//   Text,
//   Box,
//   Divider,
//   Tag,
//   TagLabel,
//   TagCloseButton,
//   Wrap,
//   WrapItem,
//   Spinner,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalCloseButton,
//   ModalBody,
// } from "@chakra-ui/react";
// import { EditIcon, CheckIcon, CloseIcon, DeleteIcon, ViewIcon } from "@chakra-ui/icons";
// import _ from "lodash";

// const ExpandedComponent = (props) => {
//   const {
//     keywordId,
//     searchTermList,
//     platforms,
//     selectedSearchTerms,
//     onSearchTermCheck,
//     onSearchTermSave,
//     onSuccessAlert,
//     onFailureAlert,
//     fetchKeywords
//   } = props;

//   const backendUrl = process.env.REACT_APP_BACKEND_URL;
//   const [data, setData] = useState([]);
//   const [tempSearchTerms, setTempSearchTerms] = useState([]);
//   const [newSearchTerm, setNewSearchTerm] = useState("");
//   const [newStatus, setNewStatus] = useState(0);
//   const [selectedPlatform, setSelectedPlatform] = useState("");
//   const [showSaveButton, setShowSaveButton] = useState(false);
//   const [inputError, setInputError] = useState(false);
//   const [negativeKeywords, setNegativeKeywords] = useState({});
//   const [positiveKeywords, setPositiveKeywords] = useState({});
//   const [loadingKeywords, setLoadingKeywords] = useState(false);
//   const [selectedRowKeywords, setSelectedRowKeywords] = useState(null);
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   const textColor = useColorModeValue("secondaryGray.900", "white");
//   const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
//   const bgColor = useColorModeValue("gray.50", "navy.700");
//   const cardBgColor = useColorModeValue("white", "navy.800");
//   const inputBgColor = useColorModeValue("white", "navy.700");

//   useEffect(() => {
//     if (searchTermList) {
//       setData(searchTermList);
//       fetchKeywordFilters();
//     }
//   }, [searchTermList, keywordId]);

//   // Fetch negative and positive keywords for this keyword_id
//   const fetchKeywordFilters = async () => {
//     try {
//       setLoadingKeywords(true);
//       const response = await fetch(`${backendUrl}/api/products/getBothExisitingKeywords`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           keyword_ids: [keywordId],
//         }),
//       });

//       if (response.ok) {
//         const json = await response.json();
//         if (json.success) {
//           setNegativeKeywords(json.data[keywordId].X || []);
//           setPositiveKeywords(json.data[keywordId].A || []);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching keyword filters:", err);
//     } finally {
//       setLoadingKeywords(false);
//     }
//   };

//   const handleAddSearchTerm = () => {
//     if (!newSearchTerm || !selectedPlatform) {
//       setInputError(true);
//       onFailureAlert("Please fill all required fields");
//       return;
//     }

//     const newItem = {
//       keyword_id: keywordId,
//       search_term: newSearchTerm,
//       pst_status: parseInt(newStatus),
//       platform_id: parseInt(selectedPlatform),
//       isTemp: true
//     };

//     setTempSearchTerms([...tempSearchTerms, newItem]);
//     setData([...data, newItem]);
//     setNewSearchTerm("");
//     setSelectedPlatform("");
//     setShowSaveButton(true);
//     setInputError(false);
//   };

//   const handleSaveAll = async () => {
//     if (tempSearchTerms.length === 0) {
//       onSuccessAlert("No changes to save");
//       return;
//     }

//     const searchTermsToSave = tempSearchTerms.map(term => ({
//       search_term: term.search_term,
//       platform_id: term.platform_id,
//       status: term.pst_status
//     }));

//     try {
//       const response = await fetch(`${backendUrl}/api/keyword/insertPst`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           keywords: data,
//         }),
//       });

//       const json = await response.json();

//       if (response.ok) {
//         onSuccessAlert("Changes Saved");
//         fetchKeywords();
//       } else if (response.status === 400) {
//         onFailureAlert("Error in insertion");
//       }
//     } catch (err) {
//       onFailureAlert("Error in insertion");
//     }

//     await onSearchTermSave(searchTermsToSave, keywordId);
//     setTempSearchTerms([]);
//     setShowSaveButton(false);
//   };

//   const handleDeleteSearchTerm = (index) => {
//     const updatedData = data.filter((_, i) => i !== index);
//     const updatedTemp = tempSearchTerms.filter((_, i) => i !== index);
//     setData(updatedData);
//     setTempSearchTerms(updatedTemp);
//     if (updatedTemp.length === 0) setShowSaveButton(false);
//   };

//   const handleViewKeywords = (item) => {
//     setSelectedRowKeywords(item);
//     setIsModalOpen(true);
//   };

//   const getPlatformName = (platformId) => {
//     const platform = platforms.find(p => p.id === platformId);
//     return platform ? platform.platform_name : `Platform ${platformId}`;
//   };

//   return (
//     <Tr>
//       <Td colSpan={6} style={{ padding: "20px" }} bg={bgColor}>
//         <VStack align="stretch" spacing="20px">
//           {/* Keywords Overview Section */}
//           {!loadingKeywords && (negativeKeywords.length > 0 || positiveKeywords.length > 0) && (
//             <Box bg={cardBgColor} p="16px" borderRadius="12px" border="1px solid" borderColor={borderColor}>
//               <Text fontSize="sm" fontWeight="600" mb="12px" color={textColor}>
//                 📋 Keyword Filters for this Brand
//               </Text>
//               <HStack spacing="20px" align="flex-start" flexWrap="wrap">
//                 {/* Negative Keywords */}
//                 {negativeKeywords.length > 0 && (
//                   <VStack align="flex-start" spacing="8px" flex="1" minW="250px">
//                     <Flex align="center" gap="8px">
//                       <Badge colorScheme="red" fontSize="xs" px="8px" py="4px">
//                         Negative
//                       </Badge>
//                       <Text fontSize="xs" fontWeight="600" color="gray.500">
//                         {negativeKeywords.length} keywords
//                       </Text>
//                     </Flex>
//                     <Wrap spacing="8px">
//                       {negativeKeywords.slice(0, 5).map((keyword, idx) => (
//                         <WrapItem key={idx}>
//                           <Tag
//                             size="sm"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="red"
//                           >
//                             <TagLabel fontSize="xs">{keyword}</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       ))}
//                       {negativeKeywords.length > 5 && (
//                         <WrapItem>
//                           <Tag
//                             size="sm"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="gray"
//                           >
//                             <TagLabel fontSize="xs">+{negativeKeywords.length - 5} more</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       )}
//                     </Wrap>
//                   </VStack>
//                 )}

//                 {/* Positive Keywords */}
//                 {positiveKeywords.length > 0 && (
//                   <VStack align="flex-start" spacing="8px" flex="1" minW="250px">
//                     <Flex align="center" gap="8px">
//                       <Badge colorScheme="green" fontSize="xs" px="8px" py="4px">
//                         Positive
//                       </Badge>
//                       <Text fontSize="xs" fontWeight="600" color="gray.500">
//                         {positiveKeywords.length} keywords
//                       </Text>
//                     </Flex>
//                     <Wrap spacing="8px">
//                       {positiveKeywords.slice(0, 5).map((keyword, idx) => (
//                         <WrapItem key={idx}>
//                           <Tag
//                             size="sm"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="green"
//                           >
//                             <TagLabel fontSize="xs">{keyword}</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       ))}
//                       {positiveKeywords.length > 5 && (
//                         <WrapItem>
//                           <Tag
//                             size="sm"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="gray"
//                           >
//                             <TagLabel fontSize="xs">+{positiveKeywords.length - 5} more</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       )}
//                     </Wrap>
//                   </VStack>
//                 )}
//               </HStack>
//             </Box>
//           )}

//           <Divider />

//           {/* Search Terms Table */}
//           <Box overflowX="auto" borderRadius="12px" border="1px solid" borderColor={borderColor}>
//             <Table variant="simple" size="sm" bg={cardBgColor}>
//               <Thead bg={bgColor}>
//                 <Tr>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     Select
//                   </Th>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     SR
//                   </Th>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     Search Term
//                   </Th>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     Status
//                   </Th>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     Platform
//                   </Th>
//                   <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
//                     Actions
//                   </Th>
//                 </Tr>
//               </Thead>
//               <Tbody>
//                 {/* Existing search terms */}
//                 {data
//                   .filter((it) => it.pst_id || it.isTemp)
//                   .map((item, index) => (
//                     <Tr key={item.pst_id || index} _hover={{ bg: bgColor }}>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         <Checkbox
//                           isChecked={selectedSearchTerms[keywordId]?.includes(
//                             item.pst_id
//                           )}
//                           onChange={() => onSearchTermCheck(keywordId, item.pst_id)}
//                           isDisabled={item.isTemp}
//                           colorScheme="blue"
//                         />
//                       </Td>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         <Text fontSize="sm" color={textColor} fontWeight="500">
//                           {index + 1}
//                         </Text>
//                       </Td>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         <Text fontSize="sm" color={textColor} fontWeight="500">
//                           {item.search_term}
//                         </Text>
//                       </Td>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         <Switch
//                           isChecked={item.pst_status === 1}
//                           colorScheme="teal"
//                           size="sm"
//                           isDisabled={item.isTemp}
//                         />
//                       </Td>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         <Badge
//                           colorScheme={item.pmp_status === 1 ? "blue" : "gray"}
//                           fontSize="xs"
//                           variant="subtle"
//                         >
//                           {item.platform_name}
//                         </Badge>
//                       </Td>
//                       <Td px="12px" py="12px" borderColor={borderColor}>
//                         {item.isTemp && (
//                           <Button
//                             size="xs"
//                             colorScheme="red"
//                             variant="ghost"
//                             leftIcon={<DeleteIcon />}
//                             onClick={() => handleDeleteSearchTerm(index)}
//                           >
//                             Remove
//                           </Button>
//                         )}
//                       </Td>
//                     </Tr>
//                   ))}

//                 {/* New search term input row */}
//                 <Tr bg={bgColor} _hover={{ bg: bgColor }}>
//                   <Td px="12px" py="16px" borderColor={borderColor}></Td>
//                   <Td px="12px" py="16px" borderColor={borderColor}>
//                     <Text fontSize="sm" fontWeight="500" color="gray.500">
//                       New
//                     </Text>
//                   </Td>
//                   <Td px="12px" py="16px" borderColor={borderColor}>
//                     <Input
//                       placeholder="Enter search term"
//                       value={newSearchTerm}
//                       onChange={(e) => setNewSearchTerm(e.target.value)}
//                       size="sm"
//                       bg={inputBgColor}
//                       borderColor={inputError && !newSearchTerm ? "red.500" : borderColor}
//                       fontSize="sm"
//                       onKeyPress={(e) => {
//                         if (e.key === "Enter") handleAddSearchTerm();
//                       }}
//                     />
//                   </Td>
//                   <Td px="12px" py="16px" borderColor={borderColor}>
//                     <Switch
//                       isChecked={newStatus === 1}
//                       onChange={() => setNewStatus(newStatus === 1 ? 0 : 1)}
//                       colorScheme="teal"
//                       size="sm"
//                     />
//                   </Td>
//                   <Td px="12px" py="16px" borderColor={borderColor}>
//                     <Select
//                       placeholder="Select platform"
//                       value={selectedPlatform}
//                       onChange={(e) => setSelectedPlatform(e.target.value)}
//                       size="sm"
//                       bg={inputBgColor}
//                       borderColor={inputError && !selectedPlatform ? "red.500" : borderColor}
//                       fontSize="sm"
//                     >
//                       {platforms.map((platform) => (
//                         <option key={platform.id} value={platform.id}>
//                           {platform.platform_name}
//                         </option>
//                       ))}
//                     </Select>
//                   </Td>
//                   <Td px="12px" py="16px" borderColor={borderColor}>
//                     <Button
//                       colorScheme="blue"
//                       size="sm"
//                       leftIcon={<CheckIcon />}
//                       onClick={handleAddSearchTerm}
//                     >
//                       Add
//                     </Button>
//                   </Td>
//                 </Tr>
//               </Tbody>
//             </Table>
//           </Box>

//           {/* Input Error Alert */}
//           {inputError && (
//             <Alert status="error" borderRadius="8px" variant="left-accent">
//               <AlertIcon />
//               Please fill all required fields
//             </Alert>
//           )}

//           {/* Save All Changes Button */}
//           {showSaveButton && (
//             <Flex justify="flex-end">
//               <Button
//                 colorScheme="green"
//                 size="md"
//                 leftIcon={<CheckIcon />}
//                 onClick={handleSaveAll}
//               >
//                 Save All Changes
//               </Button>
//             </Flex>
//           )}
//         </VStack>
//       </Td>

//       {/* Keywords Modal */}
//       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="2xl">
//         <ModalOverlay />
//         <ModalContent>
//           <ModalHeader>Keyword Filters</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody pb="20px">
//             {selectedRowKeywords && (
//               <VStack align="stretch" spacing="20px">
//                 {/* Negative Keywords */}
//                 <Box>
//                   <Flex align="center" gap="8px" mb="12px">
//                     <Badge colorScheme="red" fontSize="sm">
//                       Negative Keywords
//                     </Badge>
//                     <Text fontSize="sm" color="gray.500">
//                       ({negativeKeywords.length})
//                     </Text>
//                   </Flex>
//                   {negativeKeywords.length > 0 ? (
//                     <Wrap spacing="8px">
//                       {negativeKeywords.map((keyword, idx) => (
//                         <WrapItem key={idx}>
//                           <Tag
//                             size="md"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="red"
//                           >
//                             <TagLabel>{keyword}</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       ))}
//                     </Wrap>
//                   ) : (
//                     <Text fontSize="sm" color="gray.500">
//                       No negative keywords
//                     </Text>
//                   )}
//                 </Box>

//                 <Divider />

//                 {/* Positive Keywords */}
//                 <Box>
//                   <Flex align="center" gap="8px" mb="12px">
//                     <Badge colorScheme="green" fontSize="sm">
//                       Positive Keywords
//                     </Badge>
//                     <Text fontSize="sm" color="gray.500">
//                       ({positiveKeywords.length})
//                     </Text>
//                   </Flex>
//                   {positiveKeywords.length > 0 ? (
//                     <Wrap spacing="8px">
//                       {positiveKeywords.map((keyword, idx) => (
//                         <WrapItem key={idx}>
//                           <Tag
//                             size="md"
//                             borderRadius="full"
//                             variant="subtle"
//                             colorScheme="green"
//                           >
//                             <TagLabel>{keyword}</TagLabel>
//                           </Tag>
//                         </WrapItem>
//                       ))}
//                     </Wrap>
//                   ) : (
//                     <Text fontSize="sm" color="gray.500">
//                       No positive keywords
//                     </Text>
//                   )}
//                 </Box>
//               </VStack>
//             )}
//           </ModalBody>
//         </ModalContent>
//       </Modal>
//     </Tr>
//   );
// };

// export default ExpandedComponent;



import React, { useState, useEffect } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Button,
  Stack,
  Alert,
  AlertIcon,
  Switch,
  Checkbox,
  HStack,
  VStack,
  useColorModeValue,
  Input,
  Select,
  Flex,
  Text,
  Box,
  Divider,
  Tag,
  TagLabel,
  Wrap,
  WrapItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Spinner,
  IconButton
} from "@chakra-ui/react";
import { EditIcon, CheckIcon, DeleteIcon, ChevronLeftIcon, ChevronRightIcon } from "@chakra-ui/icons";
import _ from "lodash";
import { SearchBar } from "components/navbar/searchBar/SearchBar";


const ExpandedComponent = (props) => {
  const {
    keywordId,
    searchTermList,
    platforms,
    selectedSearchTerms,
    onSearchTermCheck,
    onSearchTermSave,
    onSuccessAlert,
    onFailureAlert,
    fetchKeywords
  } = props;

  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [data, setData] = useState([]);
  const [tempSearchTerms, setTempSearchTerms] = useState([]);
  const [newSearchTerm, setNewSearchTerm] = useState("");
  const [newStatus, setNewStatus] = useState(0);
  const [selectedPlatform, setSelectedPlatform] = useState("");
  const [showSaveButton, setShowSaveButton] = useState(false);
  const [inputError, setInputError] = useState(false);
  const [negativeKeywords, setNegativeKeywords] = useState([]);
  const [positiveKeywords, setPositiveKeywords] = useState([]);
  const [loadingKeywords, setLoadingKeywords] = useState(false);

  // Pagination states
  const [negativeCurrentPage, setNegativeCurrentPage] = useState(1);
  const [positiveCurrentPage, setPositiveCurrentPage] = useState(1);
  const itemsPerPage = 50; // Show at least 50 keywords per page
  const [negativeMode, setNegativeMode] = useState(null);
  // "add" | "edit" | "delete" | null

  const [positiveMode, setPositiveMode] = useState(null);
  // "add" | "edit" | "delete" | null

  const [newKeywordInput, setNewKeywordInput] = useState("");
  const [savingKeywords, setSavingKeywords] = useState(false);
  const [editingKeyword, setEditingKeyword] = useState(null);
  // shape: { value: string, type: "X" | "A", original: string }


  // Search states
  const [sharedSearch, setSharedSearch] = useState("");


  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  const bgColor = useColorModeValue("gray.50", "navy.700");
  const cardBgColor = useColorModeValue("white", "navy.800");
  const inputBgColor = useColorModeValue("white", "navy.700");

  useEffect(() => {
    if (searchTermList) {
      setData(searchTermList);
      fetchKeywordFilters();
    }
  }, [searchTermList, keywordId]);

  const fetchKeywordFilters = async () => {
    try {
      setLoadingKeywords(true);
      const response = await fetch(`${backendUrl}/api/products/getBothExisitingKeywords`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ keyword_ids: [keywordId] }),
      });

      if (response.ok) {
        const json = await response.json();
        if (json.success && json.data[keywordId]) {
          const keywordData = json.data[keywordId];
          setNegativeKeywords(keywordData.X);
          setPositiveKeywords(keywordData.A);
          setNegativeCurrentPage(1);
          setPositiveCurrentPage(1);
        }
      }
    } catch (err) {
      console.error("Error fetching keyword filters:", err);
      onFailureAlert("Error loading keywords");
    } finally {
      setLoadingKeywords(false);
    }
  };

  const handleAddKeyword = (type) => {
    if (!newKeywordInput.trim()) {
      onFailureAlert("Keyword cannot be empty");
      return;
    }

    if (type === "X") {
      if (negativeKeywords.includes(newKeywordInput)) return;

      const updated = [...negativeKeywords, newKeywordInput];
      setNegativeKeywords(updated);
      updateCheckKeywords("X", updated);

    } else {
      if (positiveKeywords.includes(newKeywordInput)) return;

      const updated = [...positiveKeywords, newKeywordInput];
      setPositiveKeywords(updated);
      updateCheckKeywords("A", updated);
    }

    setNewKeywordInput("");
  };


  const handleDeleteKeyword = (keyword, type) => {
    if (type === "X") {
      const updated = negativeKeywords.filter(k => k !== keyword);
      setNegativeKeywords(updated);
      updateCheckKeywords("X", updated);
    } else {
      const updated = positiveKeywords.filter(k => k !== keyword);
      setPositiveKeywords(updated);
      updateCheckKeywords("A", updated);
    }
  };

  const startEditKeyword = (keyword, type) => {
    setEditingKeyword({
      value: keyword,
      original: keyword,
      type,
    });
  };

  const cancelEditKeyword = () => {
    setEditingKeyword(null);
  };

  const saveEditKeyword = () => {
    const { original, value, type } = editingKeyword;

    if (!value.trim()) {
      onFailureAlert("Keyword cannot be empty");
      return;
    }

    if (type === "X") {
      const updated = negativeKeywords.map(k =>
        k === original ? value : k
      );
      setNegativeKeywords(updated);
      updateCheckKeywords("X", updated);
    } else {
      const updated = positiveKeywords.map(k =>
        k === original ? value : k
      );
      setPositiveKeywords(updated);
      updateCheckKeywords("A", updated);
    }

    setEditingKeyword(null);
  };

  const toggleMode = (currentMode, setMode, newMode) => {
    setMode(currentMode === newMode ? null : newMode);
  };



  const updateCheckKeywords = async (status, keywordsArray) => {
    try {
      setSavingKeywords(true);

      const response = await fetch(
        `${backendUrl}/api/keyword/updateCheckKeywords`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            keyword_id: keywordId,
            status,
            keywords: keywordsArray.join(","),
          }),
        }
      );

      const json = await response.json();

      if (!response.ok) {
        throw new Error("Failed to update keywords");
      }

      onSuccessAlert("Keywords updated successfully");
      fetchKeywordFilters();
    } catch (err) {
      console.error(err);
      onFailureAlert("Error updating keywords");
    } finally {
      setSavingKeywords(false);
    }
  };



  // Filtered keywords based on search
  const getFilteredNegativeKeywords = () =>
    negativeKeywords.filter(k => k.toLowerCase().includes(sharedSearch.toLowerCase()));

  const getFilteredPositiveKeywords = () =>
    positiveKeywords.filter(k => k.toLowerCase().includes(sharedSearch.toLowerCase()));

  const getNegativePaginatedData = () => {
    const startIndex = (negativeCurrentPage - 1) * itemsPerPage;
    return getFilteredNegativeKeywords().slice(startIndex, startIndex + itemsPerPage);
  };

  const getPositivePaginatedData = () => {
    const startIndex = (positiveCurrentPage - 1) * itemsPerPage;
    return getFilteredPositiveKeywords().slice(startIndex, startIndex + itemsPerPage);
  };

  const getNegativeTotalPages = () => Math.ceil(getFilteredNegativeKeywords().length / itemsPerPage);
  const getPositiveTotalPages = () => Math.ceil(getFilteredPositiveKeywords().length / itemsPerPage);

  const handleAddSearchTerm = () => {
    if (!newSearchTerm || !selectedPlatform) {
      setInputError(true);
      onFailureAlert("Please fill all required fields");
      return;
    }

    const newItem = {
      keyword_id: keywordId,
      search_term: newSearchTerm,
      pst_status: parseInt(newStatus),
      platform_id: parseInt(selectedPlatform),
      isTemp: true
    };

    setTempSearchTerms([...tempSearchTerms, newItem]);
    setData([...data, newItem]);
    setNewSearchTerm("");
    setSelectedPlatform("");
    setShowSaveButton(true);
    setInputError(false);
  };

  const handleSaveAll = async () => {
    if (tempSearchTerms.length === 0) {
      onSuccessAlert("No changes to save");
      return;
    }

    const searchTermsToSave = tempSearchTerms.map(term => ({
      search_term: term.search_term,
      platform_id: term.platform_id,
      status: term.pst_status
    }));

    try {
      const response = await fetch(`${backendUrl}/api/keyword/insertPst`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ keywords: data }),
      });

      const json = await response.json();

      if (response.ok) {
        onSuccessAlert("Changes Saved");
        fetchKeywords();
      } else if (response.status === 400) {
        onFailureAlert("Error in insertion");
      }
    } catch (err) {
      onFailureAlert("Error in insertion");
    }

    await onSearchTermSave(searchTermsToSave, keywordId);
    setTempSearchTerms([]);
    setShowSaveButton(false);
  };

  const handleDeleteSearchTerm = (index) => {
    const updatedData = data.filter((_, i) => i !== index);
    const updatedTemp = tempSearchTerms.filter((_, i) => i !== index);
    setData(updatedData);
    setTempSearchTerms(updatedTemp);
    if (updatedTemp.length === 0) setShowSaveButton(false);
  };

  return (
    <Tr>
      <Td colSpan={7} style={{ padding: "20px" }} >
        <Tabs variant="soft-rounded" colorScheme="blue" size="md">
          <TabList mb="1em" borderBottom="2px solid" borderColor={borderColor} pb="8px">
            <Tab fontSize="sm" fontWeight="600">
              🔍 Search Terms ({data.filter(it => it.pst_id || it.isTemp).length})
            </Tab>
            <Tab fontSize="sm" fontWeight="600">
              📋 Keywords ({negativeKeywords.length + positiveKeywords.length})
            </Tab>
          </TabList>

          <TabPanels>
            {/* TAB 1: Search Terms */}
            <TabPanel>
              <VStack align="stretch" spacing="20px">
                {/* Search Terms Table */}
                <Box overflowX="auto" borderRadius="12px" border="1px solid" borderColor={borderColor}>
                  <Table variant="simple" size="sm" bg={cardBgColor}>
                    <Thead bg={bgColor}>
                      <Tr>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          Select
                        </Th>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          SR
                        </Th>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          Search Term
                        </Th>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          Status
                        </Th>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          Platform
                        </Th>
                        <Th px="12px" py="12px" borderColor={borderColor} fontSize="xs" fontWeight="600" color="gray.500">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {/* Existing search terms */}
                      {data
                        .filter((it) => it.pst_id || it.isTemp)
                        .map((item, index) => (
                          <Tr key={item.pst_id || index} _hover={{ bg: bgColor }}>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              <Checkbox
                                isChecked={selectedSearchTerms[keywordId]?.includes(
                                  item.pst_id
                                )}
                                onChange={() => onSearchTermCheck(keywordId, item.pst_id)}
                                isDisabled={item.isTemp}
                                colorScheme="blue"
                              />
                            </Td>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              <Text fontSize="sm" color={textColor} fontWeight="500">
                                {index + 1}
                              </Text>
                            </Td>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              <Text fontSize="sm" color={textColor} fontWeight="500">
                                {item.search_term}
                              </Text>
                            </Td>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              <Switch
                                isChecked={item.pst_status === 1}
                                colorScheme="teal"
                                size="sm"
                                isDisabled={item.isTemp}
                              />
                            </Td>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              <Badge
                                colorScheme={item.pmp_status === 1 ? "blue" : "gray"}
                                fontSize="xs"
                                variant="subtle"
                              >
                                {item.platform_name}
                              </Badge>
                            </Td>
                            <Td px="12px" py="12px" borderColor={borderColor}>
                              {item.isTemp && (
                                <Button
                                  size="xs"
                                  colorScheme="red"
                                  variant="ghost"
                                  leftIcon={<DeleteIcon />}
                                  onClick={() => handleDeleteSearchTerm(index)}
                                >
                                  Remove
                                </Button>
                              )}
                            </Td>
                          </Tr>
                        ))}
                      {/* New search term input row */}
                      <Tr bg={bgColor} _hover={{ bg: bgColor }}>
                        <Td px="12px" py="16px" borderColor={borderColor}></Td>
                        <Td px="12px" py="16px" borderColor={borderColor}>
                          <Text fontSize="sm" fontWeight="500" color="gray.500">
                            New
                          </Text>
                        </Td>
                        <Td px="12px" py="16px" borderColor={borderColor}>
                          <Input
                            placeholder="Enter search term"
                            value={newSearchTerm}
                            onChange={(e) => setNewSearchTerm(e.target.value)}
                            size="sm"
                            bg={inputBgColor}
                            borderColor={inputError && !newSearchTerm ? "red.500" : borderColor}
                            fontSize="sm"
                            onKeyPress={(e) => {
                              if (e.key === "Enter") handleAddSearchTerm();
                            }}
                          />
                        </Td>
                        <Td px="12px" py="16px" borderColor={borderColor}>
                          <Switch
                            isChecked={newStatus === 1}
                            onChange={() => setNewStatus(newStatus === 1 ? 0 : 1)}
                            colorScheme="teal"
                            size="sm"
                          />
                        </Td>
                        <Td px="12px" py="16px" borderColor={borderColor}>
                          <Select
                            placeholder="Select platform"
                            value={selectedPlatform}
                            onChange={(e) => setSelectedPlatform(e.target.value)}
                            size="sm"
                            bg={inputBgColor}
                            borderColor={inputError && !selectedPlatform ? "red.500" : borderColor}
                            fontSize="sm"
                          >
                            {platforms.map((platform) => (
                              <option key={platform.id} value={platform.id}>
                                {platform.platform_name}
                              </option>
                            ))}
                          </Select>
                        </Td>
                        <Td px="12px" py="16px" borderColor={borderColor}>
                          <Button
                            colorScheme="blue"
                            size="sm"
                            leftIcon={<CheckIcon />}
                            onClick={handleAddSearchTerm}
                          >
                            Add
                          </Button>
                        </Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </Box>
                {/* Input Error Alert */}
                {inputError && (
                  <Alert status="error" borderRadius="8px" variant="left-accent">
                    <AlertIcon />
                    Please fill all required fields
                  </Alert>
                )}
                {/* Save All Changes Button */}
                {showSaveButton && (
                  <Flex justify="flex-end">
                    <Button
                      colorScheme="green"
                      size="md"
                      leftIcon={<CheckIcon />}
                      onClick={handleSaveAll}
                    >
                      Save All Changes
                    </Button>
                  </Flex>
                )}
              </VStack>
            </TabPanel>

            {/* TAB 2: Keywords */}
            <TabPanel>
              <VStack align="stretch" spacing="24px">
                {loadingKeywords ? (
                  <Flex justify="center" align="center" py="40px">
                    <Spinner mr="10px" />
                    <Text>Loading keywords...</Text>
                  </Flex>
                ) : (
                  <>
                    {/* Shared search bar */}
                    <Flex mb="16px" align="center" justify="flex-start" gap="12px">
                      <SearchBar
                        flex="1"
                        borderRadius="30px"
                        value={sharedSearch}
                        onChange={(e) => {
                          setSharedSearch(e.target.value);
                          setNegativeCurrentPage(1);
                          setPositiveCurrentPage(1);
                        }}
                        placeholder="Search keywords"
                      />

                    </Flex>

                    {/* Keywords sections */}
                    <Flex gap="24px">
                      {/* NEGATIVE KEYWORDS */}
                      <Box flex="1">
                        <Flex justify={"space-between"} mb="8px">

                          <Badge colorScheme="red" fontSize="sm" px="10px"  >
                            Negative Keywords- <b>{getFilteredNegativeKeywords().length}</b>
                          </Badge>
                          <Flex gap={2}>

                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => toggleMode(negativeMode, setNegativeMode, "add")}
                            >
                              +
                            </Button>

                            <IconButton
                              size="sm"
                              colorScheme="green"
                              variant="outline"
                              icon={<EditIcon />}
                              onClick={() => toggleMode(negativeMode, setNegativeMode, "edit")}
                            />

                            <IconButton
                              size="sm"
                              colorScheme="red"
                              variant="outline"
                              icon={<DeleteIcon />}
                              onClick={() => toggleMode(negativeMode, setNegativeMode, "delete")}
                            />


                          </Flex>

                        </Flex>
                        {negativeMode === "add" && (
                          <HStack mb="12px">
                            <Input
                              size="sm"
                              placeholder="Enter negative keyword"
                              value={newKeywordInput}
                              onChange={(e) => setNewKeywordInput(e.target.value)}
                            />
                            <Button size="sm" colorScheme="green" variant="outline" onClick={() => handleAddKeyword("X")}>
                              Save
                            </Button>
                          </HStack>
                        )}




                        {getFilteredNegativeKeywords().length > 0 ? (
                          <Box bg={cardBgColor} p="16px" borderRadius="12px" border="1px solid" borderColor={borderColor}>
                            <Wrap spacing="12px" mb="16px">
                              {getNegativePaginatedData().map((keyword, idx) => (
                                <WrapItem key={idx}>
                                  <Tag size="sm" borderRadius="full" variant="subtle" colorScheme="red" boxShadow="sm">
                                    {editingKeyword?.original === keyword && editingKeyword.type === "X" &&
                                      negativeMode === "edit" ? (
                                      <HStack spacing="4px">
                                        <Input
                                          size="xs"
                                          value={editingKeyword.value}
                                          fontSize="sm"
                                          autoFocus
                                          onChange={(e) =>
                                            setEditingKeyword({
                                              ...editingKeyword,
                                              value: e.target.value,
                                            })
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") saveEditKeyword();
                                            if (e.key === "Escape") cancelEditKeyword();
                                          }}
                                        />
                                        <CheckIcon cursor="pointer" onClick={saveEditKeyword} />
                                        <DeleteIcon cursor="pointer" onClick={cancelEditKeyword} />
                                      </HStack>
                                    ) : (
                                      <>
                                        <TagLabel fontSize="sm" fontWeight="400" onClick={() => { negativeMode === "edit" && startEditKeyword(keyword, "X") }}>{keyword}</TagLabel>
                                        {negativeMode === "delete" && (
                                          <DeleteIcon
                                            ml="6px"
                                            cursor="pointer"
                                            color="red"
                                            onClick={() => handleDeleteKeyword(keyword, "X")}
                                          />
                                        )}

                                        {negativeMode === "edit" && (
                                          <EditIcon
                                            ml="6px"
                                            cursor="pointer"
                                            color="blue"
                                            onClick={() => startEditKeyword(keyword, "X")}
                                          />
                                        )}

                                      </>
                                    )}
                                  </Tag>
                                </WrapItem>
                              ))}
                            </Wrap>
                            {getNegativeTotalPages() > 1 && (
                              <Flex justify="space-between" align="center" borderTop="1px solid" borderColor={borderColor} pt="12px">
                                <Text fontSize="xs" color="gray.500">Page {negativeCurrentPage} of {getNegativeTotalPages()}</Text>
                                <HStack spacing="8px">
                                  <Button size="sm" leftIcon={<ChevronLeftIcon />} onClick={() => setNegativeCurrentPage(Math.max(1, negativeCurrentPage - 1))} isDisabled={negativeCurrentPage === 1} variant="outline">Previous</Button>
                                  <Button size="sm" rightIcon={<ChevronRightIcon />} onClick={() => setNegativeCurrentPage(Math.min(getNegativeTotalPages(), negativeCurrentPage + 1))} isDisabled={negativeCurrentPage === getNegativeTotalPages()} variant="outline">Next</Button>
                                </HStack>
                              </Flex>
                            )}
                          </Box>
                        ) : (
                          <Alert status="info" borderRadius="8px" variant="left-accent">
                            <AlertIcon />No negative keywords found
                          </Alert>
                        )}
                      </Box>

                      {/* POSITIVE KEYWORDS */}
                      <Box flex="1">
                        <Flex justify={"space-between"} mb="8px">

                          <Badge colorScheme="green" fontSize="sm" px="10px">
                            Positive Keywords- <b>{getFilteredPositiveKeywords().length}</b>
                          </Badge>
                          <Flex gap={2}>

                            <Button
                              size="sm"
                              variant="outline"
                              onClick={() => toggleMode(positiveMode, setPositiveMode, "add")}
                            >
                              +
                            </Button>

                            <IconButton
                              size="sm"
                              colorScheme="green"
                              variant="outline"
                              icon={<EditIcon />}
                              onClick={() => toggleMode(positiveMode, setPositiveMode, "edit")}
                            />

                            <IconButton
                              size="sm"
                              colorScheme="red"
                              variant="outline"
                              icon={<DeleteIcon />}
                              onClick={() => toggleMode(positiveMode, setPositiveMode, "delete")}
                            />

                          </Flex>


                        </Flex>
                        {positiveMode === "add" && (
                          <HStack mb="12px">
                            <Input
                              size="sm"
                              placeholder="Enter Positive keyword"
                              value={newKeywordInput}
                              onChange={(e) => { e.preventDefault(); setNewKeywordInput(e.target.value) }}
                            />
                            <Button size="sm" colorScheme="green" variant="outline" onClick={() => handleAddKeyword("A")} >
                              Save
                            </Button>
                          </HStack>
                        )}

                        {getFilteredPositiveKeywords().length > 0 ? (
                          <Box bg={cardBgColor} p="16px" borderRadius="12px" border="1px solid" borderColor={borderColor}>
                            <Wrap spacing="12px" mb="16px">
                              {getPositivePaginatedData().map((keyword, idx) => (
                                <WrapItem key={idx}>
                                  <Tag size="sm" borderRadius="full" variant="subtle" colorScheme="green" boxShadow="sm">
                                    {editingKeyword?.original === keyword &&
                                      editingKeyword.type === "A" && positiveMode === "edit" ? (
                                      <HStack spacing="4px">
                                        <Input
                                          size="xs"
                                          value={editingKeyword.value}
                                          autoFocus
                                          fontSize="sm"
                                          onChange={(e) =>
                                            setEditingKeyword({
                                              ...editingKeyword,
                                              value: e.target.value,
                                            })
                                          }
                                          onKeyDown={(e) => {
                                            if (e.key === "Enter") saveEditKeyword();
                                            if (e.key === "Escape") cancelEditKeyword();
                                          }}
                                        />
                                        <CheckIcon cursor="pointer" onClick={saveEditKeyword} />
                                        <DeleteIcon cursor="pointer" onClick={cancelEditKeyword} />
                                      </HStack>
                                    ) : (<>
                                      <TagLabel fontSize="sm" fontWeight="400" onClick={()=>{positiveMode === "edit" && startEditKeyword(keyword, "A")}}>{keyword}</TagLabel>
                                      {positiveMode === "delete" &&
                                        <DeleteIcon
                                          ml="6px"
                                          cursor="pointer"
                                          onClick={() => handleDeleteKeyword(keyword, "A")}
                                          color={"red"}
                                        />
                                      }
                                      {positiveMode === "edit" &&
                                        <EditIcon
                                          ml="6px"
                                          cursor="pointer"
                                          onClick={() => startEditKeyword(keyword, "A")}
                                          color={"blue"}
                                        />
                                      }
                                    </>)}
                                  </Tag>
                                </WrapItem>
                              ))}
                            </Wrap>
                            {getPositiveTotalPages() > 1 && (
                              <Flex justify="space-between" align="center" borderTop="1px solid" borderColor={borderColor} pt="12px">
                                <Text fontSize="xs" color="gray.500">Page {positiveCurrentPage} of {getPositiveTotalPages()}</Text>
                                <HStack spacing="8px">
                                  <Button size="sm" leftIcon={<ChevronLeftIcon />} onClick={() => setPositiveCurrentPage(Math.max(1, positiveCurrentPage - 1))} isDisabled={positiveCurrentPage === 1} variant="outline">Previous</Button>
                                  <Button size="sm" rightIcon={<ChevronRightIcon />} onClick={() => setPositiveCurrentPage(Math.min(getPositiveTotalPages(), positiveCurrentPage + 1))} isDisabled={positiveCurrentPage === getPositiveTotalPages()} variant="outline">Next</Button>
                                </HStack>
                              </Flex>
                            )}
                          </Box>
                        ) : (
                          <Alert status="info" borderRadius="8px" variant="left-accent">
                            <AlertIcon />No positive keywords found
                          </Alert>
                        )}
                      </Box>
                    </Flex>
                  </>
                )}
              </VStack>
            </TabPanel>

          </TabPanels>
        </Tabs>
      </Td>
    </Tr>
  );
};


export default ExpandedComponent;